var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C1B008D-1BE6-4001-AEEE-F330C3EB86D1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.61022775,-8.8817842e-15 C9.13205973,-8.8817842e-15 9.47994772,0.261206063 9.69737771,0.478877781 C11.8716776,2.65559497 14.0894636,4.83231216 16.2637635,6.965495 L18.8294374,9.53402128 C19.4378066,10.1435021 19.4378066,10.7529829 18.8294374,11.3624637 L11.4368177,18.8503708 C11.2193877,19.1546759 10.9149857,19.2857143 10.6105837,19.2857143 C10.3061817,19.2857143 10.0022146,19.1546759 9.74086371,18.8503708 L8.21885376,17.3702032 C5.69666583,14.8452112 3.13099191,12.3202193 0.608803982,9.83876169 C0.217429994,9.4469526 0.0434859987,9.0551435 0.0434859987,8.53273138 L-1.49213975e-13,5.00644953 L-1.49213975e-13,1.30603031 C-1.49213975e-13,0.522412125 0.478345986,0.0435343438 1.26109396,0.0435343438 L3.2614499,0.0435343438 C5.04437585,0.0435343438 6.8273018,0.0435343438 8.61022775,-8.8817842e-15 Z M8.65371374,0.872428249 C6.8707878,0.872428249 5.08786185,0.872428249 3.2614499,0.915962593 L1.26109396,0.915962593 C0.913205973,0.915962593 0.869719974,1.00303128 0.869719974,1.35130603 L0.913205973,8.53273138 C0.913205973,8.83747178 1.00017797,9.01160916 1.21760796,9.22928088 C3.73979589,11.7542728 6.30546981,14.2357304 8.82765774,16.7607223 L10.3496677,18.24089 C10.5670977,18.4585618 10.6975557,18.4585618 10.9149857,18.24089 L18.3076055,10.7529829 C18.5685215,10.4917768 18.5685215,10.4047082 18.3076055,10.1439374 L15.6984455,7.62025153 C13.5241456,5.44353434 11.3063597,3.26681716 9.13205973,1.13363431 C8.95811574,0.959496936 8.82765774,0.872428249 8.65371374,0.872428249 Z M4.03897956,2.225911 C5.08177381,2.225911 5.9306205,3.07570139 5.9306205,4.11965495 C5.9306205,5.16360851 5.08177381,6.0133989 4.03897956,6.0133989 C2.99618531,6.0133989 2.14733862,5.16360851 2.14733862,4.11965495 C2.14733862,3.07570139 2.99618531,2.225911 4.03897956,2.225911 Z M4.03897956,2.96599484 C3.40364912,2.96599484 2.88660059,3.48318284 2.88660059,4.11965495 C2.88660059,4.75612706 3.40321426,5.27331506 4.03897956,5.27331506 C4.67474486,5.27331506 5.19135853,4.75612706 5.19135853,4.11965495 C5.19135853,3.48318284 4.67431,2.96599484 4.03897956,2.96599484 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R3-Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R3-WebApp---Story-Review-(Static)",
    transform: "translate(-745.000000, -347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(342.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-Bank",
    transform: "translate(24.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(379.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-App-Icon/-Creativity-Copy-13",
    transform: "translate(0.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(5.357143, 5.357143)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#8688A1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.357143, -5.357143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientCare);
export default __webpack_public_path__ + "static/media/Patient Care.c8c16913da9f8a7425918079b8f28754.svg";
export { ForwardRef as ReactComponent };